export enum QueryKey {
  UserCountry = 'UserCountry',
  User = 'User',
  Me = 'Me',
  Account = 'Account',
  Signer = 'Signer',
  Network = 'Network',
  Fund = 'Fund',
  Contract = 'Contract',
  Funds = 'Funds',
  FundMetadata = 'FundMetadata',
  StrapiFundsList = 'StrapiFundsList',
  Nfts = 'Nfts',
  Nft = 'Nft',
  NftTokens = 'NftTokens',
  NftToken = 'NftToken',
  NftTransactionId = 'NftTransactionId',
  GenesisNfts = 'GenesisNfts',
  GenesisNft = 'GenesisNft',
  GenesisNftTokens = 'GenesisNftTokens',
  GenesisNftToken = 'GenesisNftToken',
  GenesisNftBalanceOf = 'GenesisNftBalanceOf',
  GenesisNftStaking = 'GenesisNftStaking',
  Projects = 'Projects',
  ProjectsMetadata = 'ProjectsMetadata',
  ProjectMetadata = 'ProjectMetadata',
  FavouriteProjects = 'FavouriteProjects',
  Project = 'Project',
  FundListProjects = 'FundListProjects',
  FundWithdrawalCarryFee = 'FundWithdrawalCarryFee',
  WlthToken = 'WlthToken',
  WlthProceeds = 'WlthProceeds',
  WlthStakingInfo = 'WlthStakingInfo',
  WlthEstimatedDiscountInTimestamp = 'WlthEstimatedDiscountInTimestamp',
  WlthTokenPrice = 'WlthTokenPrice',
  WlthEstimatedDiscount = 'WlthEstimatedDiscount',
  UsdcToken = 'UsdcToken',
  UsdcTokenBalance = 'UsdcTokenBalance',
  UsdcPriceHistory = 'UsdcPriceHistory',
  UsdcPriceFromUniswap = 'UsdcPriceFromUniswap',
  TokenPriceHistory = 'TokenPriceHistory',
  MultipleTokenPrices = 'MultipleTokenPrices',
  VestingTotalAllocation = 'VestingTotalAllocation',
  VestingGetVestedAmount = 'VestingGetVestedAmount',
  Notifications = 'Notifications',
  FundInvestGasFee = 'FundInvestGasFee',
  NftSplitGasFee = 'NftSplitGasFee',
  Currencies = 'Currencies',
  GetDiscount = 'GetDiscount',
  ClaimWLTHUnclaimedTokens = 'ClaimWLTHUnclaimedTokens',
  ClaimProfitReleasableAmount = 'ClaimProfitReleasableAmount',
  ClaimProfitReleasableAmountAll = 'ClaimProfitReleasableAmountAll',
  ClaimInvestmentProfitAllReleasableAmount = 'ClaimInvestmentProfitAllReleasableAmount',
  WlthTokenDetails = 'WlthTokenDetails',
  WlthPriceHistory = 'WlthPriceHistory',
  ClaimInvestmentFundProfitReleasableAmount = 'ClaimInvestmentFundProfitReleasableAmount',
  GenesisNFTVestingDetails = 'GenesisNFTVestingDetails',
  CheckIfGenesisNFTTokenExist = 'CheckIfGenesisNFTTokenExist',
  ClaimRewardsReleasableAmount = 'ClaimRewardsReleasableAmount',
  TreasuryBuckets = 'TreasuryBuckets',
  WlthDayAgoDetails = 'WlthDayAgoDetails',
  DDProductDesc = 'DDProductDesc',
  DDTeamInfo = 'DDTeamInfo',
  ForumLatestTopics = 'ForumLatestTopics',
  ForumPopularTopics = 'ForumPopularTopics',
  NewDiscount = 'NewDiscount',
  PenaltyForUnstaking = 'PenaltyForUnstaking',
  FreeFundProjects = 'FreeFundProjects',
  Quest = 'Quest',
  MissionTreePath = 'MissionTreePath',
  Mission = 'Mission',
  Leaderboard = 'Leaderboard',
  LeaderboardPosition = 'LeadearboardPosition',
  LeaderboardClosestUsers = 'LeaderboardClosestUsers',
  PromotedMissions = 'PromotedMissions',
  QuestCount = 'QuestCount',
  MeMissions = 'MeMissions',
  TermsAndConditions = 'TermsAndConditions',
  PrivacyPolicy = 'PrivacyPolicy',
  WlthPolicy = 'WlthPolicy',
  Wallets = 'Wallets',
  EquityStakingState = 'EquityStakingState',
  EquityGenesisAssets = 'EquityGenesisAssets',
  EquityOwnedSlices = 'EquityOwnedSlices',
  EquityStakeActivity = 'EquityStakeActivity',
  MandatoryMissions = 'MandatoryMissions',
  MissionsCount = 'MissionsCount',
  FundInvestmentNftInfo = 'FundInvestmentNftInfo',
  UserCanInvestInFund = 'UserCanInvestInFund',
  IDOBanner = 'IDOBanner',
  GamificationPenalty = 'GamificationPenalty',
  GenesisNftLeftTokens = 'GenesisNftLeftTokens',
  StakeForBonusRewardInfo = 'StakeForBonusRewardInfo',
  StakeForBonusInfo = 'StakeForBonusInfo',
  StrategicPartnersVestingInfo = 'StrategicPartnersVestingInfo',
  StrategicPartnersVestingDetailedInfo = 'StrategicPartnersVestingDetailedInfo',
  StrategicPartnersAccelerateVestingPenalty = 'StrategicPartnersAccelerateVestingPenalty',
  StrategicPartners1AccelerateVestingPenalty = 'StrategicPartners1AccelerateVestingPenalty',
  StrategicPartners1VestingInfo = 'StrategicPartners1VestingInfo',

  AllocatedTokens = 'AllocatedTokens',
  CommunityFund = 'CommunityFund',
  MarketplaceCollection = 'MarketplaceCollection',
  AllStakers = 'AllStakers',
  AllStakersMyPosition = 'AllStakersMyPosition',
  AllStakersMyPositionWithNeighbors = 'AllStakersMyPositionWithNeighbors',
  TopStakers = 'TopStakers',
  TopStakersMyPosition = 'TopStakersMyPosition',
  TopStakersMyPositionWithNeighbors = 'TopStakersMyPositionWithNeighbors',

  PortfolioValue = 'PortfolioValue',
  PerpetualFundDistribution = 'PerpetualFundDistribution',
  FundValuation = 'FundValuation',
  StakingForParticipationStakingInfo = 'StakingForParticipationStakingInfo',
  StakingForParticipationSummary = 'StakingForParticipationSummary',

  InvestmentStatus = 'InvestmentStatus',
  TopFiveTokenValuation = 'TopFiveTokenValuation',
  MyDETFInvestments = 'MyDETFInvestments',
  UserRewards = 'UserRewards',
  TwitterToken = 'TwitterToken',
  AllocationSlices = 'AllocationSlices',
  NftReleasableAmount = 'NftReleasableAmount',
  TokenClaimDetails = 'TokenClaimDetails',
  AllBundleGifts = 'AllBundleGifts',
  SingleProjectFund = 'SingleProjectFund',
  EthBalance = 'EthBalance',
  MarketplaceCollectionListings = 'MarketplaceCollectionListings',
  MarketplaceCollectionListingsByListingId = 'MarketplaceCollectionListingsByListingId',
  ReferralStats = 'ReferralStats',
  ReferralDashboard = 'ReferralDashboard',
  St0xTokens = 'St0xTokens',
  St0xTokenBalance = 'St0xTokenBalance',
  GlobalReferralStats = 'GlobalReferralStats',
  ReferralGiveawayLeaderboard = 'ReferralGiveawayLeaderboard',
  ReferralPositionWithNeighbors = 'ReferralPositionWithNeighbors',
  PreIpoFundDetails = 'PreIpoFundDetails',
  PreIpoInterest = 'PreIpoInterest',
  PartnerPreIpoInterestDashboard = 'PartnerPreIpoInterestDashboard',
  PartnerPreIpoInterestTimeseries = 'PartnerPreIpoInterestTimeseries',
  PartnerPreIpoInterestRegistrations = 'PartnerPreIpoInterestRegistrations',
  CanSponsorTransaction = 'CanSponsorTransaction',
  OffersCount = 'OffersCount',
  NewsArticles = 'NewsArticles',
  Cart = 'Cart',
  CartCount = 'CartCount',
  Favorites = 'Favorites',
  FavoritesExists = 'FavoritesExists',
  UserTerms = 'UserTerms',
  InvestmentWhitelistStatus = 'InvestmentWhitelistStatus',
  PreIpoLowestInAppValuations = 'PreIpoLowestInAppValuations',
  MarketplaceBestDeals = 'MarketplaceBestDeals',
  MarketplaceListingBids = 'MarketplaceListingBids',
  MarketplaceMyBids = 'MarketplaceMyBids',
  MarketplaceSellerBidInbox = 'MarketplaceSellerBidInbox',
  SupportDeskWalletBalances = 'SupportDeskWalletBalances',
  SupportDeskFundSlices = 'SupportDeskFundSlices',
  SupportDeskOwnershipSlices = 'SupportDeskOwnershipSlices',
  SupportDeskWalletActivity = 'SupportDeskWalletActivity',
  HoldingProfitSummary = 'HoldingProfitSummary',
  RemainingAssetBps = 'RemainingAssetBps',
}
